import { http, HttpResponse } from 'msw'

import { VendorTypes } from '../../entities/enums/VendorTypeEnum'
import { VendorApiModelStub } from '../api-models/stubs/VendorApiModel.stub'
import { type VendorApiModel } from '../api-models/VendorApiModel'

// Inline provider creation from CreditCardProviderSelect (BHV-018) —
// POST /api/v3/vendors/ with { name, email: [], type: 6 }.
export const mockCreateCreditCardProviderSuccess = (
  params: Partial<VendorApiModel> = {}
) => {
  return http.post(
    `/api/v3/vendors/`,
    async ({ request }) => {
      const body = (await request.json()) as { name?: string }
      const data = VendorApiModelStub.build({
        type: VendorTypes.CREDIT_CARD_PROVIDER,
        ...(body?.name ? { name: body.name } : {}),
        ...params,
      })

      return HttpResponse.json({ data }, { status: 201 })
    },
    { once: true }
  )
}
